/* eslint-disable */

import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';

export type GetTracesWithErrorsQueryVariables = Types.Exact<{
    service?: Types.Maybe<Types.Scalars['String']>;
    limit?: Types.Maybe<Types.Scalars['Int']>;
    location?: Types.Maybe<Types.Scalars['String']>;
    timeframe?: Types.Maybe<Types.Scalars['Int']>;
}>;

export type GetTracesWithErrorsQuery = {
    __typename: 'Query';
    dev: Types.Maybe<{
        __typename: 'Dev';
        tracesWithErrors: Array<Types.Maybe<{ __typename: 'Trace'; id: string; title: string }>>;
    }>;
};

export const GetTracesWithErrorsDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetTracesWithErrors' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'service' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    defaultValue: { kind: 'StringValue', value: 'bastion', block: false },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'location' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'timeframe' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dev' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'tracesWithErrors' },
                                    arguments: [
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'input' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'limit' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: { kind: 'Name', value: 'limit' },
                                                        },
                                                    },
                                                    {
                                                        kind: 'ObjectField',
                                                        name: {
                                                            kind: 'Name',
                                                            value: 'serviceName',
                                                        },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'service',
                                                            },
                                                        },
                                                    },
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'location' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'location',
                                                            },
                                                        },
                                                    },
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'timeframe' },
                                                        value: {
                                                            kind: 'Variable',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'timeframe',
                                                            },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'title' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};

/**
 * __useGetTracesWithErrorsQuery__
 *
 * To run a query within a React component, call `useGetTracesWithErrorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTracesWithErrorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTracesWithErrorsQuery({
 *   variables: {
 *      service: // value for 'service'
 *      limit: // value for 'limit'
 *      location: // value for 'location'
 *      timeframe: // value for 'timeframe'
 *   },
 * });
 */
export function useGetTracesWithErrorsQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetTracesWithErrorsQuery,
        GetTracesWithErrorsQueryVariables
    >
) {
    return Apollo.useQuery<GetTracesWithErrorsQuery, GetTracesWithErrorsQueryVariables>(
        GetTracesWithErrorsDocument,
        baseOptions
    );
}
export function useGetTracesWithErrorsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetTracesWithErrorsQuery,
        GetTracesWithErrorsQueryVariables
    >
) {
    return Apollo.useLazyQuery<GetTracesWithErrorsQuery, GetTracesWithErrorsQueryVariables>(
        GetTracesWithErrorsDocument,
        baseOptions
    );
}
export type GetTracesWithErrorsQueryHookResult = ReturnType<typeof useGetTracesWithErrorsQuery>;
export type GetTracesWithErrorsLazyQueryHookResult = ReturnType<
    typeof useGetTracesWithErrorsLazyQuery
>;
export type GetTracesWithErrorsQueryResult = Apollo.QueryResult<
    GetTracesWithErrorsQuery,
    GetTracesWithErrorsQueryVariables
>;
